import React from 'react'
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/Weather-img.png";
import projImg7 from "../assets/img/omniverse-project.png";
import colorSharp2 from "../assets/img/color-sharp2.png";

import ProjectCard from "./ProjectCard";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const Projects = () => {
  const projects = [
    {
      title: "Weather App",
      description: "Did you want to check the weather for where you are now or where you're visiting ❓..................... Just with simple clicks you can see the details even use the JSON formatted data for more accuracy",
      techStack:['Angular','Open Weather API'],
      imgUrl: projImg6,
      websiteUrl: 'https://weatherwaytest.netlify.app/'
    },
    {
      title: "3D application",
      description: "3D application Created for learning perspective of Locomotive Gsap",
      techStack:['Javascript', 'HTML/CSS','GSAP'],
      imgUrl: projImg7,
      websiteUrl: 'https://akshim1702.github.io/3D-omniverse/'
    },
    {
      title: "Social Book",
      description: "Social Media Application created to Upload images and share your thoughts with different people Currently unavailable because of excessive budget",
      imgUrl: projImg5,
      techStack:['React JS', 'Node js', 'Multer','Firebase'],
      websiteUrl: 'https://social-book-b35a1.web.app/'
    },
    {
      title: "Snake Game",
      description: "Created a simple snake game using Javascript",
      imgUrl: projImg4,
      techStack:['Javascript', 'HTML/CSS'],
      websiteUrl: 'https://akshim1702.github.io/Snake-game/'
    },

  ]
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>Some of my personal project i have listed over here. Will add more soon...</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Web Application</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">ML Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Others...</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <p>
                          Something is cooking on backend will be served soon ....
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>
                          Some Exceptions are going to be demonstrated over here till then wait and watch 😁😁😁😁...
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}

export default Projects